var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProjectsActive = function SvgProjectsActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205 213.15a63.74 63.74 0 0 0 90.12 90.15A63.73 63.73 0 0 0 205 213.15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M283.6 32a223 223 0 0 0-33.6-2.59C128.17 29.41 29.41 128.17 29.41 250c0 110.41 81.11 201.87 187 218.05a223 223 0 0 0 33.6 2.54h1.89c117.15-1 212.53-93.29 218.4-209.21q.3-5.64.3-11.35c0-110.44-81.11-201.9-187-218.03m111.65 250.5-121 121a34.31 34.31 0 0 1-48.52 0l-121-121a34.31 34.31 0 0 1 0-48.52l121-121a34.31 34.31 0 0 1 48.52 0l121 121a34.32 34.32 0 0 1 0 48.52"
  })));
};
export default SvgProjectsActive;